__turbopack_context__.v({
  "body": "style-module-scss-module__7sa4ja__body",
  "button": "style-module-scss-module__7sa4ja__button",
  "size__L": "style-module-scss-module__7sa4ja__size__L",
  "size__L__lg": "style-module-scss-module__7sa4ja__size__L__lg",
  "size__L__md": "style-module-scss-module__7sa4ja__size__L__md",
  "size__L__sm": "style-module-scss-module__7sa4ja__size__L__sm",
  "size__L__xl": "style-module-scss-module__7sa4ja__size__L__xl",
  "size__L__xxl": "style-module-scss-module__7sa4ja__size__L__xxl",
  "size__M": "style-module-scss-module__7sa4ja__size__M",
  "size__M__lg": "style-module-scss-module__7sa4ja__size__M__lg",
  "size__M__md": "style-module-scss-module__7sa4ja__size__M__md",
  "size__M__sm": "style-module-scss-module__7sa4ja__size__M__sm",
  "size__M__xl": "style-module-scss-module__7sa4ja__size__M__xl",
  "size__M__xxl": "style-module-scss-module__7sa4ja__size__M__xxl",
  "size__S": "style-module-scss-module__7sa4ja__size__S",
  "size__S__lg": "style-module-scss-module__7sa4ja__size__S__lg",
  "size__S__md": "style-module-scss-module__7sa4ja__size__S__md",
  "size__S__sm": "style-module-scss-module__7sa4ja__size__S__sm",
  "size__S__xl": "style-module-scss-module__7sa4ja__size__S__xl",
  "size__S__xxl": "style-module-scss-module__7sa4ja__size__S__xxl",
  "type__round": "style-module-scss-module__7sa4ja__type__round",
  "type__square": "style-module-scss-module__7sa4ja__type__square",
  "variant__bubbleOutline": "style-module-scss-module__7sa4ja__variant__bubbleOutline",
  "variant__fill": "style-module-scss-module__7sa4ja__variant__fill",
  "variant__grey": "style-module-scss-module__7sa4ja__variant__grey",
  "variant__premium": "style-module-scss-module__7sa4ja__variant__premium",
});
